export const TEXTS = {
  TITLE_VERIFY_EMAIL: 'Verify Your Email',
  SUBTITLE_VERIFY_EMAIL: (email) =>
    `We've sent an email to ${email}. Please check the inbox and verify your email.`,
  BACK_TO_LOGIN: 'Back to Login',
  ALREADY_VERIFIED: 'ALREADY_VERIFIED',
  TITLE_ALREADY_VERIFY_EMAIL: 'Email already verified',
  SUBTITLE_ALREADY_VERIFY_EMAIL: `This email has already been verified. If you don't recognize this action please contact us.`,
  TITLE_VERIFIED_EMAIL: 'Email Verified',
  SUBTITLE_VERIFIED_EMAIL: 'Your email address was successfully verified.',
}
